import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, FeeRecord } from '@tassat/fred-definitions';

export interface FeeState {
    [key: string]: FeeRecord;
}

const initialState: FeeState = {};

const initialLoadAction = createAction<{
    feeRecords: {
        [key: string]: FeeRecord;
    };
}>('InitialLoad');
const feeRecordAction = createAction<FeeRecord>(CoreMsgTypes.FeeRecord);

const feesSlice = createSlice({
    name: 'fees',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (state, action) => {
                if (action.payload.feeRecords) {
                    Object.keys(action.payload.feeRecords)
                        .forEach(key => {
                            const fee = action.payload.feeRecords[key];
                            state[fee.FeeApply] = fee;
                        });
                }
            })
            .addCase(feeRecordAction, (state, action) => {
                state[action.payload.FeeApply] = action.payload;
            });
    }
});

export default feesSlice.reducer;